import { render } from "./OverDetails.vue?vue&type=template&id=1fac5576&scoped=true"
import script from "./OverDetails.vue?vue&type=script&lang=js"
export * from "./OverDetails.vue?vue&type=script&lang=js"

import "./OverDetails.vue?vue&type=style&index=0&id=1fac5576&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fac5576"]])

export default __exports__